import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function OurGallerySection() {
  const [clickCount, setClickCount] = useState(0);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [mediaType, setMediaType] = useState<'photo' | 'video'>('photo');
  const [mediaFile, setMediaFile] = useState<File | null>(null);
  const [mediaPreview, setMediaPreview] = useState('');
  const [uploadError, setUploadError] = useState('');
  const [showAllMobile, setShowAllMobile] = useState(false);
  const [galleryItems, setGalleryItems] = useState<Array<{
    id: number;
    type: 'photo' | 'video';
    url: string;
    title: string;
  }>>([
    {
      id: 1,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/552c436790787b901a179141977928e5.jpeg',
      title: 'Main Gym Floor'
    },
    {
      id: 2,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/5cc04a490b3b2d1fe68cc26e38ed9bc3.jpeg',
      title: 'Personal Training'
    },
    {
      id: 3,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/568428acc5e78396b8f5f48b48a97f3e.jpeg',
      title: 'Group Classes'
    },
    {
      id: 4,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/abbaafdab8492395789a4c5bbb600229.jpeg',
      title: 'Cardio Zone'
    },
    {
      id: 5,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/e81e73f2409fa46feec29d286e44f151.jpeg',
      title: 'Strength Training'
    },
    {
      id: 6,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/9f351a7c3e8f940b96767e69c8097b0b.jpeg',
      title: 'Locker Rooms'
    },
    {
      id: 7,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/928216f941d08559c9589e725333d51f.jpeg',
      title: 'Functional Training Area'
    },
    {
      id: 8,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/f549e142498bbe10f0c0691c3afffd4d.jpeg',
      title: 'Free Weights Section'
    },
    {
      id: 9,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/7d010e4b401ee24e62f84d7286582e4f.jpeg',
      title: 'Stretching & Recovery Zone'
    },
    {
      id: 10,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/aded99c36d629d527e5b77ab0b2bbeaa.jpeg',
      title: 'Group Fitness Studio'
    },
    {
      id: 11,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/52c7f15b6055a2acc6bc9e9f480029f8.jpeg',
      title: 'Cycling Studio'
    },
    {
      id: 12,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/b7464e4b8a5a46100895678d6dd23310.jpeg',
      title: 'Reception Area'
    },
    {
      id: 13,
      type: 'photo',
      url: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/766b9fa1b822b0329fa456ed6582f30b.jpeg',
      title: 'Premium Cardio Equipment'
    }
  ]);

  const handleBadgeClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    
    if (newCount === 5) {
      setShowPasswordModal(true);
      setClickCount(0);
    }
  };

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'hfc@2025') {
      setIsAdmin(true);
      setShowPasswordModal(false);
      setPassword('');
      setPasswordError('');
    } else {
      setPasswordError('Incorrect password');
    }
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadError('');

    // Validate file type
    if (mediaType === 'photo') {
      if (!file.type.startsWith('image/')) {
        setUploadError('Please select an image file');
        return;
      }
      // Max 5MB for images
      if (file.size > 5 * 1024 * 1024) {
        setUploadError('Image size should be less than 5MB');
        return;
      }
    } else {
      if (!file.type.startsWith('video/')) {
        setUploadError('Please select a video file');
        return;
      }
      // Max 50MB for videos
      if (file.size > 50 * 1024 * 1024) {
        setUploadError('Video size should be less than 50MB');
        return;
      }
    }

    setMediaFile(file);

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setMediaPreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const handleAddMedia = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!mediaFile || !mediaPreview) {
      setUploadError('Please select a file to upload');
      return;
    }

    const newItem = {
      id: Date.now(),
      type: mediaType,
      url: mediaPreview,
      title: mediaType === 'photo' ? 'Photo' : 'Video'
    };
    setGalleryItems([...galleryItems, newItem]);
    setShowAddModal(false);
    setMediaFile(null);
    setMediaPreview('');
    setMediaType('photo');
    setUploadError('');
  };

  const handleClearFile = () => {
    setMediaFile(null);
    setMediaPreview('');
    setUploadError('');
  };

  const handleDeleteItem = (id: number) => {
    setGalleryItems(galleryItems.filter(item => item.id !== id));
  };

  return (
    <section className="py-6 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-4 lg:mb-12">
          <div 
            onClick={handleBadgeClick}
            className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-100 text-red-700 rounded-lg text-[10px] lg:text-sm font-bold mb-1.5 lg:mb-4 uppercase tracking-wider cursor-pointer select-none"
          >
            VISUAL SHOWCASE
          </div>
          <h3 className="text-xl lg:text-5xl font-black text-gray-900 mb-1.5 lg:mb-4">
            Our <span className="text-red-600">Gallery</span>
          </h3>
          <p className="text-[10px] lg:text-lg text-gray-600 max-w-2xl mx-auto hidden lg:block">
            Explore our state-of-the-art facility, premium equipment, and vibrant fitness community through our collection of photos and videos
          </p>
        </div>

        {/* Admin Controls */}
        {isAdmin && (
          <div className="mt-3 mb-4 lg:mt-8 lg:mb-8 flex justify-center gap-2 lg:gap-4">
            <Button
              onClick={() => setShowAddModal(true)}
              variant="primary"
              icon="ri-add-line"
              iconPosition="left"
              className="px-3 py-1.5 lg:px-6 lg:py-3 text-xs lg:text-base"
            >
              Add Media
            </Button>
            <Button
              onClick={() => setIsAdmin(false)}
              variant="secondary"
              icon="ri-logout-box-line"
              iconPosition="left"
              className="px-3 py-1.5 lg:px-6 lg:py-3 text-xs lg:text-base"
            >
              Exit Admin
            </Button>
          </div>
        )}

        {/* Gallery Grid - Show 4 on mobile by default */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-1.5 lg:gap-6 mt-4 lg:mt-12">
          {galleryItems.map((item, index) => (
            <div
              key={item.id}
              className={`group relative rounded-lg lg:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 ${
                !showAllMobile && index >= 4 ? 'hidden lg:block' : ''
              }`}
            >
              {/* Media Content */}
              <div className="relative w-full h-24 lg:h-80">
                {item.type === 'photo' ? (
                  <img
                    src={item.url}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                ) : (
                  <video
                    src={item.url}
                    controls
                    className="w-full h-full object-cover object-top"
                  />
                )}
              </div>

              {/* Delete Button (Admin Only) */}
              {isAdmin && (
                <button
                  onClick={() => handleDeleteItem(item.id)}
                  className="absolute top-1.5 right-1.5 lg:top-3 lg:right-3 w-6 h-6 lg:w-10 lg:h-10 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer z-10"
                >
                  <i className="ri-delete-bin-line text-white text-xs lg:text-lg"></i>
                </button>
              )}
            </div>
          ))}
        </div>

        {/* View All Button - Mobile Only */}
        {!showAllMobile && galleryItems.length > 4 && (
          <div className="lg:hidden text-center mt-3">
            <Button
              onClick={() => setShowAllMobile(true)}
              variant="primary"
              icon="ri-arrow-down-s-line"
              iconPosition="right"
              className="text-[10px] px-4 py-2"
            >
              View All Photos ({galleryItems.length})
            </Button>
          </div>
        )}
      </div>

      {/* Password Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl lg:rounded-2xl p-6 lg:p-8 max-w-md w-full shadow-2xl">
            <div className="text-center mb-4 lg:mb-6">
              <div className="w-12 h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-3 lg:mb-4">
                <i className="ri-lock-line text-2xl lg:text-3xl text-red-600"></i>
              </div>
              <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-1 lg:mb-2">Admin Access</h3>
              <p className="text-gray-600 text-xs lg:text-base">Enter password to manage gallery</p>
            </div>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError('');
                }}
                placeholder="Enter password"
                className="w-full px-3 py-2.5 lg:px-4 lg:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 mb-3 lg:mb-4 text-sm"
                autoFocus
              />
              {passwordError && (
                <p className="text-red-600 text-xs lg:text-sm mb-3 lg:mb-4">{passwordError}</p>
              )}
              <div className="flex gap-2 lg:gap-3">
                <Button
                  onClick={() => {
                    setShowPasswordModal(false);
                    setPassword('');
                    setPasswordError('');
                  }}
                  variant="secondary"
                  className="flex-1 px-3 py-2.5 lg:px-4 lg:py-3 text-xs lg:text-base"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="submit"
                  icon="ri-lock-unlock-line"
                  iconPosition="left"
                  className="flex-1 px-3 py-2.5 lg:px-4 lg:py-3 text-xs lg:text-base"
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Add Media Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl lg:rounded-2xl p-6 lg:p-8 max-w-md w-full shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="text-center mb-4 lg:mb-6">
              <div className="w-12 h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-3 lg:mb-4">
                <i className="ri-image-add-line text-2xl lg:text-3xl text-red-600"></i>
              </div>
              <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-1 lg:mb-2">Add Media</h3>
              <p className="text-gray-600 text-xs lg:text-base">Upload a photo or video to the gallery</p>
            </div>
            <form onSubmit={handleAddMedia}>
              <div className="mb-3 lg:mb-4">
                <label className="block text-xs lg:text-sm font-semibold text-gray-700 mb-1.5 lg:mb-2">
                  Media Type
                </label>
                <div className="flex gap-3 lg:gap-4">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value="photo"
                      checked={mediaType === 'photo'}
                      onChange={(e) => {
                        setMediaType(e.target.value as 'photo' | 'video');
                        handleClearFile();
                      }}
                      className="mr-1.5 lg:mr-2 cursor-pointer"
                    />
                    <span className="text-gray-700 text-xs lg:text-base">Photo</span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      value="video"
                      checked={mediaType === 'video'}
                      onChange={(e) => {
                        setMediaType(e.target.value as 'photo' | 'video');
                        handleClearFile();
                      }}
                      className="mr-1.5 lg:mr-2 cursor-pointer"
                    />
                    <span className="text-gray-700 text-xs lg:text-base">Video</span>
                  </label>
                </div>
              </div>

              <div className="mb-4 lg:mb-6">
                <label className="block text-xs lg:text-sm font-semibold text-gray-700 mb-1.5 lg:mb-2">
                  {mediaType === 'photo' ? 'Upload Photo' : 'Upload Video'}
                </label>
                <input
                  type="file"
                  accept={mediaType === 'photo' ? 'image/*' : 'video/*'}
                  onChange={handleFileUpload}
                  className="w-full px-3 py-2.5 lg:px-4 lg:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 text-xs lg:text-sm cursor-pointer file:mr-3 lg:file:mr-4 file:py-1.5 lg:file:py-2 file:px-3 lg:file:px-4 file:rounded-lg file:border-0 file:text-xs lg:file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100 file:cursor-pointer"
                />
                <p className="text-[10px] lg:text-xs text-gray-500 mt-1.5 lg:mt-2">
                  {mediaType === 'photo' 
                    ? 'Maximum file size: 5MB. Supported formats: JPG, PNG, GIF, WebP' 
                    : 'Maximum file size: 50MB. Supported formats: MP4, WebM, MOV'}
                </p>
                {uploadError && (
                  <p className="text-red-600 text-xs lg:text-sm mt-1.5 lg:mt-2">{uploadError}</p>
                )}
              </div>

              {/* Preview */}
              {mediaPreview && (
                <div className="mb-4 lg:mb-6">
                  <label className="block text-xs lg:text-sm font-semibold text-gray-700 mb-1.5 lg:mb-2">
                    Preview
                  </label>
                  <div className="relative w-full rounded-lg overflow-hidden border-2 border-gray-200">
                    {mediaType === 'photo' ? (
                      <div className="relative w-full h-36 lg:h-48">
                        <img
                          src={mediaPreview}
                          alt="Preview"
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    ) : (
                      <div className="relative w-full h-36 lg:h-48">
                        <video
                          src={mediaPreview}
                          controls
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={handleClearFile}
                      className="absolute top-1.5 right-1.5 lg:top-2 lg:right-2 w-6 h-6 lg:w-8 lg:h-8 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                    >
                      <i className="ri-close-line text-white text-sm lg:text-lg"></i>
                    </button>
                  </div>
                </div>
              )}

              <div className="flex gap-2 lg:gap-3">
                <Button
                  onClick={() => {
                    setShowAddModal(false);
                    setMediaFile(null);
                    setMediaPreview('');
                    setMediaType('photo');
                    setUploadError('');
                  }}
                  variant="secondary"
                  className="flex-1 px-3 py-2.5 lg:px-4 lg:py-3 text-xs lg:text-base"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="submit"
                  icon="ri-image-add-line"
                  iconPosition="left"
                  className="flex-1 px-3 py-2.5 lg:px-4 lg:py-3 text-xs lg:text-base"
                >
                  Add Media
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
